export const isLoading = (state) => state.transfer.isLoading
export const isSuccess = (state) => state.transfer.isSuccess
export const contracts = (state) => state.transfer.contracts
